<div *ngIf="routeInfo" class="route-detail-container">
  <ng-container *ngFor="let bus of routeInfo.Flights; index as i">
    <app-bus-info [companyCode]="bus.AirlineCode" [opTerminalCode]="bus.OpAirlineCode" [number]="bus.Number"
      [departureDate]="bus.DepartureDate" [departureTerminal]="bus.DepartureAirport" [arrivalDate]="bus.ArrivalDate"
      [arrivalTerminal]="bus.ArrivalAirport" [busClass]="busClass" [travelInfoProvider]="flightInfoProvider"
      [bus]="bus.Equipment">
    </app-bus-info>
    <app-flight-segment-connection [hasScales]="hasScales" [provider]="flightInfoProvider"
      [isScaleElement]="isScaleElement(i)" [isConnectionInDifferentAirport]="bus.IsConnectionInDifferentAirport"
      [numberOfStops]="bus.NumberOfStops" [totalDuration]="routeInfo.TotalDuration"
      [technicalStopAirport]="bus.TechnicalStopAirport" [technicalStopTime]="bus.TechnicalStopTime"
      [flight]="busItem(i)" [nextFlight]="nextFlightItem(i)">
    </app-flight-segment-connection>
  </ng-container>
</div>